module.exports = __webpack_public_path__ + "img/cidade.6832b0a7.png";